import React, { useState, useEffect } from "react";
import VerifyAdd from "./VerifyAdd";
import "./clinics.css";
import axios from "axios";
import { APIURL } from "../../../Global";
import { useAlert } from "react-alert";
import { FaToggleOff } from "react-icons/fa";
import { FaToggleOn } from "react-icons/fa";

function FeaturesAdd(props) {
    const [show, setShow] = useState(false);
    const [selectedFeature, setSelectedFeature] = useState(null);
    const [purchasedFeatures, setPurchasedFeatures] = useState([]);
    const [remainingFeatures, setRemainingFeatures] = useState([]);
    const [amounts, setAmounts] = useState({});
    const [refresh, setRefresh] = useState(false);
    const [loading, setLoading] = useState(false);
    const user = JSON.parse(sessionStorage.getItem("logindatas"));
    const alert = useAlert();
    const [count, setCount] = useState(0);

    useEffect(() => {
        sessionStorage.removeItem("counterData");
    }, []);

    useEffect(() => {
        const checkAndClearStatus = () => {
            const expiry = sessionStorage.getItem("status_expiry");
            if (expiry && Date.now() > parseInt(expiry, 10)) {
                sessionStorage.removeItem("status");
                sessionStorage.removeItem("status_expiry");
            }
        };

        checkAndClearStatus();
        const interval = setInterval(checkAndClearStatus, 60 * 1000);

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        const tokenString = sessionStorage.getItem("usertoken");
        let authToken = tokenString.replace(/["]+/g, "");

        const fetchFeatures = axios.get(`${APIURL}/api/v1/staff/special-feature/?requested_user=${user.user_type}`, {
            headers: { Authorization: "Token " + authToken },
        });

        const fetchPurchases = axios.get(`${APIURL}/api/v1/staff/special-feature/?requested_user=${user.user_type}&hospital_id=${props.id}`, {
            headers: { Authorization: "Token " + authToken },
        });

        Promise.all([fetchFeatures, fetchPurchases])
            .then(([featuresRes, purchasesRes]) => {
                if (featuresRes.status === 200 && purchasesRes.status === 200) {
                    const featuresList = featuresRes.data.message || [];
                    const userFeaturesList = purchasesRes.data.data || [];

                    setPurchasedFeatures(userFeaturesList);
                    const purchasedFeatureNames = new Set(userFeaturesList.map(item => item.features));
                    const remainingFeatures = featuresList.filter(feature => !purchasedFeatureNames.has(feature.features__feature_name));
                    setRemainingFeatures(remainingFeatures);
                }
            })
            .catch(err => console.error("Error fetching data:", err));
    }, [refresh]);

    const incrementCounter = () => {
        const newCount = count + 1;
        setCount(newCount);

        sessionStorage.setItem("counterData", JSON.stringify({
            count: newCount,
            timestamp: Date.now()
        }));

        setTimeout(() => {
            sessionStorage.removeItem("counterData");
            setCount(0);
        }, 60000);
    };

    const handleBuyFeature = (feature) => {
        setSelectedFeature(feature);
        const status = sessionStorage.getItem("status");
        if (status) {
            confirmOTP(feature);
        } else {
            setShow(true);
        }
    };

    const confirmOTP = (feature) => {
        setLoading(true);
        const tokenString = sessionStorage.getItem("usertoken");
        let v2 = tokenString.replace(/["]+/g, "");
        const rawData = {
            requested_user: user.user_type,
            hospital_id: +props.id,
            feature_id: feature?.features_id,
            feature_price: Number(feature.price),
            custom_price: amounts[feature.features_id] === undefined ? feature.price : Number(amounts[feature.features_id]),
            payment_status: feature.payment_status,
            start_date: feature.start_date,
            end_date: feature.end_date,
            created_by: user.user_id
        };

        const data = Object.fromEntries(
            Object.entries(rawData).filter(([_, value]) => value !== null)
        );

        axios.post(`${APIURL}/api/v1/staff/special-feature/`, data, {
            headers: { Authorization: "Token " + v2 },
        })
            .then((res) => {
                if (res.data.status === 'success') {
                    alert.success('Successfully updated');
                    incrementCounter();
                    setRefresh(!refresh);
                } else {
                    alert.error(res.data.message);
                }
            })
            .catch((err) => {
                alert.error('Failed to update feature.');
            })
            .finally(() => {
                setLoading(false);
            });

        setShow(false);
        setSelectedFeature(null);
    };

    const handleActivity = (item) => {
        const tokenString = sessionStorage.getItem("usertoken");
        let v2 = tokenString.replace(/["]+/g, "");
        const data = {
            requested_user: user.user_type,
            id: item.id,
            is_active: !item.is_active,
        };

        axios.put(`${APIURL}/api/v1/staff/special-feature/`, data, {
            headers: { Authorization: "Token " + v2 },
        })
            .then((res) => {
                if (res.data.status === 'success') {
                    alert.success('Successfully updated');
                    setRefresh(!refresh);
                } else {
                    alert.error(res.data.message);
                }
            })
            .catch((err) => {
                alert.error('Failed to update feature.');
            });
    };

    const handleAmountChange = (featureId, value) => {
        const numericValue = Number(value);
        if (!isNaN(numericValue) && numericValue >= 0) {
            setAmounts((prev) => ({
                ...prev,
                [featureId]: numericValue,
            }));
        }
    };

    return (
        <div>
            <div style={{ marginBottom: "10px" }}>
                {remainingFeatures?.length > 0 && <div style={{ display: "flex", backgroundColor: "rgba(85, 71, 159, 0.72)", color: "white", textAlign: "left", padding: "1%", borderRadius: "5px 5px 0px 0px" }}>
                    <div className="col-3"><b>Features</b></div>
                    <div className="col-3 centre"><b>Feature Amount</b></div>
                    <div className="col-3 centre"><b>Custom Amount</b></div>
                    <div className="col-3 centre"><b>Status</b></div>
                </div>}
                {remainingFeatures.map((item, index) => (
                    <div key={index} style={{ display: "flex", overflowY: "auto", padding: "1% 0", textAlign: "left", borderLeft: "0.4px solid gray", borderBottom: "0.4px solid gray", borderRight: "0.4px solid gray" }}>
                        <div className="col-3">
                            {item?.features__feature_name?.replace(/_/g, " ").replace(/\b\w/g, char => char.toUpperCase())}
                        </div>
                        <div className="col-3 centre">{item.price || "-"}</div>
                        <div className="col-3 centre"><input
                            type="number"
                            value={amounts[item.features_id] ?? item.price}
                            onChange={(e) => handleAmountChange(item.features_id, e.target.value)}
                        />
                        </div>
                        <div className="col-3 centre">
                            {(item.payment_status && item.payment_status !== "not_paid") ?
                                <b style={{ color: "green" }}>Purchased</b>
                                : item.payment_status === "not_paid" && item.status === "accepted" ? (
                                    <b style={{ color: "green" }}>Purchased</b>
                                ) : item.status === "pending" ? (
                                    <b style={{ color: "orange" }}>Pending</b>
                                ) : (
                                    <button

                                        onClick={() => {
                                            if (!loading && count < 4) { handleBuyFeature(item) }
                                            else if (count >= 4) { alert.error('Try again after a minute') }
                                        }}
                                        style={{
                                            backgroundColor: "orange",
                                            color: "white",
                                            border: "none",
                                            padding: "5px 10px",
                                            borderRadius: "5px",
                                            cursor: loading ? "wait" : "pointer"
                                        }}
                                    >
                                        Add
                                    </button>
                                )}
                        </div>
                    </div>
                ))}
            </div>
            {purchasedFeatures?.length > 0 ? (
                <div style={{ marginBottom: "10px" }}>
                    <div style={{ display: "flex", backgroundColor: "rgba(85, 71, 159, 0.72)", color: "white", textAlign: "left", padding: "1%", borderRadius: "5px 5px 0px 0px" }}>
                        <div className="col-3"><b>Features</b></div>
                        <div className="col-2 centre"><b>Purchased Date</b></div>
                        <div className="col-2 centre"><b>Feature Amount</b></div>
                        <div className="col-2 centre"><b>Custom Amount</b></div>
                        <div className="col-2 centre"><b>Status</b></div>
                        <div className="col-1 centre"><b>Activate</b></div>
                    </div>
                    {purchasedFeatures.map((item, index) => (
                        <div key={index} style={{ display: "flex", overflowY: "auto", padding: "1% 0", textAlign: "left", borderLeft: "0.4px solid gray", borderBottom: "0.4px solid gray", borderRight: "0.4px solid gray" }}>
                            <div className="col-3">{item?.features?.replace(/_/g, " ").replace(/\b\w/g, char => char.toUpperCase())}</div>
                            <div className="col-2 centre">{item.start_date || "-"}</div>
                            <div className="col-2 centre">{item.feature_price || "-"}</div>
                            <div className="col-2 centre">{item.custom_price || "-"}</div>
                            <div className="col-2 centre">
                                {(item.payment_status !== "not_paid") ?
                                    <b style={{ color: "green" }}>Purchased</b>
                                    : <b style={{ color: "orange" }}>Pending</b>
                                }
                            </div>
                            <div className="col-1 centre">
                                {item.is_active && item.payment_status !== "not_paid" ? <FaToggleOn style={{ cursor: item.payment_status !== "not_paid" ? "pointer" : "not-allowed", height: "21px", color: "green", width: "25px" }} onClick={() => handleActivity(item)} />
                                    : <FaToggleOff style={{ cursor: item.payment_status !== "not_paid" ? "pointer" : "not-allowed", height: "21px", color: "#7e7676", width: "25px" }} onClick={() => item.payment_status !== "not_paid" && handleActivity(item)} />}
                            </div>
                        </div>
                    ))}
                </div>) : <label>No features are requested</label>}
            {show && (
                <VerifyAdd
                    onSuccess={() => {
                        const expirationTime = Date.now() + 30 * 60 * 1000;
                        sessionStorage.setItem("status", "user verified");
                        sessionStorage.setItem("status_expiry", expirationTime.toString());
                        confirmOTP(selectedFeature);
                    }}
                    show={show}
                    onHide={() => {
                        setShow(false);
                        setSelectedFeature(null);
                    }}
                />
            )}
        </div>
    );
}

export default FeaturesAdd;